import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';

const propTypes = {
  children: PropTypes.node.isRequired,
  direction: PropTypes.oneOf(['left', 'right']),
  scrollSpeed: PropTypes.number,
};
const defaultProps = { direction: 'left', scrollSpeed: 0.5 };

function InfiniteGallery({ children, direction, scrollSpeed }) {
  const containerRef = useRef(null);
  const childRef = useRef(null);
  let scrollInterval;

  useEffect(() => {
    const container = containerRef.current;

    if (container && container.scrollWidth) {
      if (direction === 'right') {
        container.scrollLeft = container.scrollWidth - container.clientWidth;
      }

      scrollInterval = setInterval(scrollContainer, 20);
    }

    return () => clearInterval(scrollInterval);
  }, [containerRef.current, childRef.current]);

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      container.addEventListener('wheel', preventScroll, { passive: false });
      container.addEventListener('touchstart', preventScroll, { passive: false });
      container.addEventListener('touchmove', preventScroll, { passive: false });
      container.addEventListener('touchend', preventScroll, { passive: false });
    }
    return () => {
      container.removeEventListener('wheel', preventScroll);
      container.removeEventListener('touchstart', preventScroll);
      container.removeEventListener('touchmove', preventScroll);
      container.removeEventListener('touchend', preventScroll);
    };
  }, [containerRef.current]);

  function scrollContainer() {
    if (direction === 'left') {
      scrollRight();
    } else {
      scrollLeft();
    }
  }

  function scrollRight() {
    const container = containerRef.current;
    container.scrollLeft += scrollSpeed;

    if (container.scrollLeft + 0.5 === container.scrollWidth - container.clientWidth) {
      container.scrollLeft = 0;
    }
  }

  function scrollLeft() {
    const container = containerRef.current;
    container.scrollLeft -= scrollSpeed;

    if (container.scrollLeft === 0) {
      container.scrollLeft += container.scrollWidth - container.clientWidth;
    }
  }

  function preventScroll(event) {
    event.preventDefault();
  }

  console.log();

  return (
    <div
      className="infinite-gallery-container d-flex flex-gap-lg"
      style={{ overflowX: 'scroll' }}
      ref={containerRef}
    >
      <div className="infinite-gallery-child  d-flex flex-gap-lg" ref={childRef}>
        {children}
      </div>
    </div>
  );
}

InfiniteGallery.propTypes = propTypes;
InfiniteGallery.defaultProps = defaultProps;

export default InfiniteGallery;
